<app-card>
  <ng-container *ngIf="(pointCloud$ | async) as pointCloud">
    <div *ngIf="pointCloud.status === 'FINISHED'" class="relative sizer aspect-video -mx-6 -my-8">
      <div class="w-full h-full">
        <div class="w-full h-full aspect-video" #viewer></div>
        <div class="absolute inset-0 pointer-events-none flex items-center justify-center" [class.opacity-0]="!loading">
          <app-loader></app-loader>
        </div>

        <div class="absolute right-5 top-5" *ngIf="!isModifying && !(standalone$ | async)">
          <app-button text="{{ 'page.project-point-cloud.viewer.modify-coordinates' | translate }}" variant="plain" icon="/assets/images/icon-pencil.svg" (click)="modifyCoordinates()"></app-button>
        </div>
      </div>

      <div class="flex-grow-0 flex-shrink-0 w-72 absolute bg-white top-0 right-0 bottom-0 px-6 py-8 bg-opacity-80 shadow-2xl flex flex-col gap- overflow-y-auto3" *ngIf="isModifying"
           [formGroup]="form">
        <h3 class="font-bold">{{ 'page.project-point-cloud.viewer.modify-coordinates.title' | translate }}</h3>

        <p class="text-xs">
          {{ 'page.project-point-cloud.viewer.modify-coordinates.instructions' | translate }}
        </p>

        <ul class="list-disc pl-4">
          <li class="text-xs">{{ 'page.project-point-cloud.viewer.modify-coordinates.anchor-point' | translate }}</li>
          <li class="text-xs">{{ 'page.project-point-cloud.viewer.modify-coordinates.reference-point' | translate }}</li>
        </ul>

        <ng-container *ngIf="isSteppointOne">
          <h4 class="font-semibold text-sm">{{ 'page.project-point-cloud.viewer.modify-coordinates.step1-title' | translate }}</h4>
          <p class="text-xs">
            {{ 'page.project-point-cloud.viewer.modify-coordinates.step1-instructions' | translate }}
          </p>

          <p class="text-xs" *ngIf="pointOne">
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.x' | translate }}:</span> {{ pointOne.x | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.y' | translate }}:</span> {{ pointOne.y | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.z' | translate }}:</span> {{ pointOne.z | number:'0.5-5' }}
          </p>

          <div formGroupName="pointOne" *ngIf="pointOne" class="flex flex-col gap-3">
            <p class="text-xs">
              {{ 'page.project-point-cloud.viewer.modify-coordinates.enter-new-coordinates' | translate }}
            </p>

            <div class="flex flex-col gap-1">
              <app-input formControlName="newX" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lat' | translate }}" type="number"></app-input>
              <app-input formControlName="newY" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lng' | translate }}" type="number"></app-input>
              <app-input formControlName="newZ" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.height' | translate }}" type="number"></app-input>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSteppointTwo">
          <h4 class="font-semibold text-sm">{{ 'page.project-point-cloud.viewer.modify-coordinates.step2-title' | translate }}</h4>
          <p class="text-xs">
            {{ 'page.project-point-cloud.viewer.modify-coordinates.step2-instructions' | translate }}
          </p>

          <p class="text-xs" *ngIf="pointTwo">
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.x' | translate }}:</span> {{ pointTwo.x | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.y' | translate }}:</span> {{ pointTwo.y | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.z' | translate }}:</span> {{ pointTwo.z | number:'0.5-5' }}
          </p>

          <div formGroupName="pointTwo" *ngIf="pointTwo" class="flex flex-col gap-3">
            <p class="text-xs">
              {{ 'page.project-point-cloud.viewer.modify-coordinates.enter-new-coordinates' | translate }}
            </p>

            <div class="flex flex-col gap-1">
              <app-input formControlName="newX" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lat' | translate }}" type="number"></app-input>
              <app-input formControlName="newY" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lng' | translate }}" type="number"></app-input>
              <app-input formControlName="newZ" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.height' | translate }}" type="number"></app-input>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSteppointThree">
          <h4 class="font-semibold text-sm">{{ 'page.project-point-cloud.viewer.modify-coordinates.step3-title' | translate }}</h4>
          <p class="text-xs">
            {{ 'page.project-point-cloud.viewer.modify-coordinates.step3-instructions' | translate }}
          </p>

          <p class="text-xs" *ngIf="pointThree">
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.x' | translate }}:</span> {{ pointThree.x | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.y' | translate }}:</span> {{ pointThree.y | number:'0.5-5' }}<br>
            <span class="font-semibold">{{ 'page.project-point-cloud.viewer.modify-coordinates.z' | translate }}:</span> {{ pointThree.z | number:'0.5-5' }}
          </p>

          <div formGroupName="pointThree" *ngIf="pointThree" class="flex flex-col gap-3">
            <p class="text-xs">
              {{ 'page.project-point-cloud.viewer.modify-coordinates.enter-new-coordinates' | translate }}
            </p>

            <div class="flex flex-col gap-1">
              <app-input formControlName="newX" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lat' | translate }}" type="number"></app-input>
              <app-input formControlName="newY" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.lng' | translate }}" type="number"></app-input>
              <app-input formControlName="newZ" prepend="{{ 'page.project-point-cloud.viewer.modify-coordinates.height' | translate }}" type="number"></app-input>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isSuccessful">
          <h4 class="font-semibold text-sm">{{ 'page.project-point-cloud.viewer.modify-coordinates.success-title' | translate }}</h4>
          <p class="text-xs">
            {{ 'page.project-point-cloud.viewer.modify-coordinates.success-message' | translate }}
          </p>
        </ng-container>

        <ng-container *ngIf="isError">
          <h4 class="font-semibold text-sm">{{ 'page.project-point-cloud.viewer.modify-coordinates.error-title' | translate }}</h4>
          <p class="text-xs">
            {{ 'page.project-point-cloud.viewer.modify-coordinates.error-message' | translate }}
          </p>
        </ng-container>

        <div class="mt-auto flex flex-col gap-1">
          <app-button *ngIf="(pointOne && isSteppointOne) || (pointTwo && isSteppointTwo)" text="{{ 'page.project-point-cloud.viewer.modify-coordinates.next' | translate }}" (click)="nextStep()"></app-button>
          <app-button *ngIf="(pointThree && isSteppointThree)" text="{{ 'page.project-point-cloud.viewer.modify-coordinates.confirm' | translate }}" (click)="confirm()" [loading]="loadingModification"></app-button>
          <app-button *ngIf="isSteppointTwo || isSteppointThree" text="{{ 'page.project-point-cloud.viewer.modify-coordinates.back' | translate }}" (click)="backStep()" variant="plain"></app-button>
          <app-button *ngIf="isSteppointOne || isSuccessful || isError" text="{{ 'page.project-point-cloud.viewer.modify-coordinates.cancel' | translate }}" (click)="close()" variant="plain"></app-button>
        </div>
      </div>
    </div>

    <div *ngIf="pointCloud.status !== 'FINISHED'" class="flex items-center justify-center h-64">
      <div class="text-center">
        <h3 class="text-lg font-semibold mb-2">{{ 'page.point-cloud-detail-viewer.not-ready.title' | translate }}</h3>
        <p class="text-sm text-gray-500 mt-2">{{ 'page.point-cloud-detail-viewer.not-ready.description' | translate }}</p>
      </div>
    </div>
  </ng-container>
</app-card>
